import FilterAltOffRounded from "@mui/icons-material/FilterAltOffRounded";
import PaidRounded from "@mui/icons-material/PaidRounded";
import TuneRounded from "@mui/icons-material/TuneRounded";
import VisibilityOffRounded from "@mui/icons-material/VisibilityOffRounded";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import type { ReactElement } from "react";
import pageData from "../../data/pages/solutions-pii-redaction.json";
import { CardsSection } from "../../components/CardsSection";
import type { MdaiCardProps } from "../../components/MdaiCard";
import { MdaiTable } from "../../components/MdaiTable";
import { PageTemplate } from "../../components/PageTemplate";
import type { SolutionDetailPageTemplate } from "../../types/solutionDetailPageTemplate";
import { resolveCdnAssetUrl } from "../../utils/cdnAssetUrl";

const typedPageData = pageData as SolutionDetailPageTemplate;
const CARD_ICONS = [FilterAltOffRounded, TuneRounded, VisibilityOffRounded, PaidRounded] as const;

const PIIRedactionCards: MdaiCardProps[] = (typedPageData.cards ?? []).map((card, index) => ({
  Icon: CARD_ICONS[index] ?? FilterAltOffRounded,
  title: card.title,
  body: card.body,
}));

const takeawaySection = typedPageData.cardsSections?.find((s) => s.id === "takeaway");

export default function PiiRedaction(): ReactElement {
  return (
    <Box>
      <PageTemplate
        id="pii-redaction"
        hero={{
          title: typedPageData.hero.title,
          image: typedPageData.hero.image
            ? {
                src: resolveCdnAssetUrl(typedPageData.hero.image.src),
                alt: typedPageData.hero.image.alt,
                flip: typedPageData.hero.image.flip,
              }
            : undefined,
          subtitle: typedPageData.hero.subtitle,
          buttons: typedPageData.hero.button
            ? [{ text: typedPageData.hero.button.text, href: typedPageData.hero.button.href }]
            : [],
        }}
        topTabs={{
          headline: typedPageData.topTabs.headline,
          caption: (
            <>
              {typedPageData.topTabs.caption
                .split("\n")
                .filter(Boolean)
                .map((line, index) => {
                  if (line.startsWith("- ")) {
                    return (
                      <Typography
                        key={`pii-caption-bullet-${index.toString()}`}
                        variant="subtitle2"
                        textAlign="left"
                        sx={{ pl: 2 }}
                      >
                        {line}
                      </Typography>
                    );
                  }

                  return (
                    <Typography
                      key={`pii-caption-${index.toString()}`}
                      variant="subtitle2"
                      mb={2}
                      textAlign="left"
                    >
                      {line}
                    </Typography>
                  );
                })}
            </>
          ),
          tabs: (typedPageData.topTabs.tabs ?? []).map((tab) => ({
            src: resolveCdnAssetUrl(tab.src),
            title: tab.title,
            type: tab.type ?? "image",
            alt: tab.alt,
          })),
        }}
        sections={
          <>
            {typedPageData.table && (
              <MdaiTable
                id="pii-redaction"
                tableTitle={typedPageData.table.title}
                headers={typedPageData.table.headers}
                rows={typedPageData.table.rows}
              />
            )}
            <CardsSection
              title={takeawaySection?.title}
              cards={PIIRedactionCards}
            />
          </>
        }
        bottomButton={typedPageData.bottomButton}
      />
    </Box>
  );
}

